export const loanTypesSummary = [
  {
    path: '/loanTypesSummary',
    name: 'loanTypesSummary',
    component: () => import('views/loanTypesSummary/index'),
    meta: {
      title: '商户贷'
    }
  },
  {
    path: '/loanTypesSummary/empty',
    name: 'loanTypesEmpty',
    component: () => import('views/loanTypesSummary/noPower'),
    meta: {
      title: '商户贷'
    }
  }
]

export const loanMerchantE = [ {
  path: '/loanMerchantE',
  name: 'loanMerchantE',
  component: () => import('views/loanMerchantE/index'),
  meta: {
    title: '预授信模式'
  }
}]

export const loanPersonal = [
  {
    path: '/loanPersonal',
    name: 'loanPersonal',
    component: () => import('views/loanPersonal/index'),
    meta: {
      title: '个人贷'
    }
  }
]
